import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Gift = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="gift icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M30 0C33.866 0 37 3.13401 37 7C37 8.95908 36.1945 10.7294 34.8975 12H45C46.6569 12 48 13.3431 48 15V21C48 22.6569 46.6569 24 45 24H44V45L43.9961 45.1543C43.9184 46.6883 42.6883 47.9184 41.1543 47.9961L41 48H7L6.8457 47.9961C5.31166 47.9184 4.08163 46.6883 4.00391 45.1543L4 45V24H3C1.34315 24 0 22.6569 0 21V15C0 13.3431 1.34315 12 3 12H14.5293C13.5788 10.9384 13 9.53707 13 8C13 4.68629 15.6863 2 19 2C20.8501 2 22.5039 2.83792 23.6045 4.1543C24.6951 1.70684 27.1475 0 30 0ZM6 45C6 45.5523 6.44772 46 7 46H20V24H6V45ZM22 46H26V24H22V46ZM28 46H41C41.5523 46 42 45.5523 42 45V24H28V46ZM3 14C2.44772 14 2 14.4477 2 15V21C2 21.5523 2.44772 22 3 22H20V14H3ZM22 22H26V14H22V22ZM28 22H45C45.5523 22 46 21.5523 46 21V15C46 14.4477 45.5523 14 45 14H28V22ZM30 2C27.2386 2 25 4.23858 25 7V12H30C32.7614 12 35 9.76142 35 7C35 4.23858 32.7614 2 30 2ZM19 4C16.7909 4 15 5.79086 15 8C15 10.2091 16.7909 12 19 12H23V8C23 5.79086 21.2091 4 19 4Z"
    />
  </svg>
)
